import { container } from '@/container';
import { mapState } from 'vuex';

/**
 * This mixin can be used in a component whose job it is to display a single Vue component for the whole page.
 */
export const FullPageContainerMixin = {
    computed: {
        ...mapState([
            'currentPageHash',
            'activeFullPageComponent',
        ]),
    },

    watch: {
        currentPageHash: {
            handler(newHash) {
                this.setActiveFullPageComponent(newHash);
            },
            // We need to run the watcher immediately in case we are starting from a Vue page.
            immediate: true,
        },
    },

    methods: {
        setActiveFullPageComponent(currentPageHash) {
            const component = this.getFullPageComponentForHash(currentPageHash);

            container.$timeout(() => {
                // We use $rootScope.hideAngularApp to control whether the AngularJS app container defined in
                // /epos/index.html should be displayed or not because we want to hide the Angular view when using a
                // full page Vue view.
                container.$rootScope.hideAngularApp = !!component;
            });

            this.$store.commit('setActiveFullPageComponent', component);
        },

        // Implement this method in a component that uses this mixin:
        // getFullPageComponentForHash(currentPageHash) {
        //     switch (currentPageHash) {
        //         case '#/example':
        //             return {
        //                 componentName: 'ExampleView',
        //                 props: {},
        //             };
        //     }
        //     return null;
        // },
    },
};
